//import CryptoJS from "crypto-js";
//const REACT_APP_SECRET_KEY = "rqXL3cXOOpKlUeZ7dSP8QBuvbMHPVBxG"
// const REACT_APP_SECRET_KEY = "Fonemed@secret_Key91740"
import { encryptionkey } from "../environment"

const cipher = salt => {
    const textToChars = text => text?.split('').map(c => c?.charCodeAt(0));
    const byteHex = n => ("0" + Number(n)?.toString(16)).slice(-2);
    const applySaltToChar = code => textToChars(salt)?.reduce((a, b) => a ^ b, code);
    return text => text?.split('')
        ?.map(textToChars)
        ?.map(applySaltToChar)
        ?.map(byteHex)
        ?.join('');
}
const decipher = salt => {
    const textToChars = text => text?.split('')?.map(c => c?.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded?.match(/.{1,2}/g)
        ?.map(hex => parseInt(hex, 16))
        ?.map(applySaltToChar)
        ?.map(charCode => String.fromCharCode(charCode))
        ?.join('');
}
// To create a cipher
const encrypt = cipher("")
const decrypt = decipher("")

//Encrypt data
export const encryptData = (data) => {
    //return encrypt(data)
    return data
    //return CryptoJS.AES.encrypt(data, REACT_APP_SECRET_KEY)?.toString()
}

//Decrypt Data
export const decryptData = (data) => {
    //return decrypt(data)
    return data
    //return CryptoJS.AES.decrypt(data, REACT_APP_SECRET_KEY)?.toString(CryptoJS.enc.Utf8);
}